import { __assign, __rest } from "tslib";
/* eslint-disable */

/* tslint:disable */

import React from 'react';

var play_background = function play_background(_a) {
  var size = _a.size,
      props = __rest(_a, ["size"]);

  return React.createElement("svg", __assign({
    viewBox: "0 0 60 60",
    fill: "currentColor",
    width: size || "60",
    height: size || "60"
  }, props), React.createElement("path", {
    d: "M30,0c16.6,0,30,13.4,30,30S46.6,60,30,60C13.4,60,0,46.6,0,30S13.4,0,30,0z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
};

play_background.displayName = 'play_background';
export default play_background;
/* tslint:enable */

/* eslint-enable */